import { useLocalParticipant } from "@livekit/components-react"
import { NavigationRefContext } from "@common/utils/mobileUtils"
import { setCameraStatus } from "@data/redux/actions/activity"
import { useContext } from "react"
import { useDispatch, useSelector } from "react-redux"

export function useCamera(formId = "default") {
    const navigationRefContext = useContext(NavigationRefContext)
    const dispatch = useDispatch()
    const { isCameraEnabled } = useLocalParticipant()
    const isLiveModeEnabled = useSelector(
        (state) => state.liveMode?.isLiveModeEnabled
    )

    const launchCamera = () => {
        if (isLiveModeEnabled && isCameraEnabled) {
            // Camera is on in live: navigate immediately, reuse the LiveKit
            // video track. Still needs cameraOn so ModalM hides whatever
            // window (chat, etc.) is on top — without it the camera screen
            // renders behind it.
            // Gated on the ref actually existing (risk-review): otherwise
            // navigate() silently no-ops, CameraComponent never mounts, and
            // cameraOn — set true here but only ever cleared by that
            // component's unmount effect — would stay stuck for the rest of
            // the session with no screen to show for it.
            const navigationRef = navigationRefContext?.navigationRef?.current
            if (navigationRef) {
                // reusesLiveTrack=true: LKVideoCallPortal must not release the
                // LiveKit camera here (its cameraOn effect was written for the
                // other branch below, a separate device capture, where
                // freeing the live camera avoids contention with a second
                // getUserMedia call) — this screen reuses that same
                // publication, disabling it would kill the picture and drop
                // the live feed for everyone else watching this participant.
                dispatch(setCameraStatus(true, true))
                navigationRef.navigate("camera", { formId, useLiveTrack: true })
            }
        } else {
            // Camera off or not in live: exact same flow as main.
            dispatch(setCameraStatus(true))
            setTimeout(() => {
                navigationRefContext?.navigationRef?.current?.navigate(
                    "camera",
                    { formId }
                )
            }, 1000)
        }
    }

    return [launchCamera]
}
